export const MARK_COMMENT = "comment";